<template>
  <div class="topic-page">
    <div class="page-content">
      <topic-header :subtopicShow.sync="subtopicShow" :subtopicInfo="subtopicInfo" :statisticsInfo="statisticsInfo" @complete="complete" />
      <table-topic ref="topictype1" v-if="topicInfo.topic_type * 1 === 1" v-model="score" :isHand.sync="isHand" :topicInfo="topicInfo" :scoreList="scoreList" :projectVisible.sync="projectVisible" @toggle-project="handleToggleProject" @table-total-change="tableTotalChange" />
      <practice-topic ref="topictype2" v-if="topicInfo.topic_type * 1 === 2" v-model="score" :isHand.sync="isHand" :topicInfo="topicInfo" :subtopicShow.sync="subtopicShow" @subtopic-change="subtopicChange" @statistics-change="statisticsChange" />
      <judgment-topic ref="topictype3" v-if="topicInfo.topic_type * 1 === 3" v-model="score" :isHand.sync="isHand" :topicInfo="topicInfo" />
      <time-topic ref="topictype4" v-if="topicInfo.topic_type * 1 === 4" v-model="score" :isHand.sync="isHand" :topicInfo="topicInfo" />
      <single-topic ref="topictype5" v-if="topicInfo.topic_type * 1 === 5" v-model="score" :isHand.sync="isHand" :topicInfo="topicInfo" />
      <label-topic ref="topictype6" v-if="topicInfo.topic_type * 1 === 6" v-model="score" :isHand.sync="isHand" :topicInfo="topicInfo" />
      <topic-footer v-if="topicInfo.topic_id && !subtopicShow" v-model="score" :isHand.sync="isHand" :topicInfo="topicInfo" :tableTotal="tableTotal" @toggle-project="handleToggleProject" @toggle-mode="toggleMode" @prev="onClickPrev" @next="onClickNext" />
      <!-- 分数弹框 -->
      <score-modal v-if="!projectVisible && !subtopicShow" :scoreList="scoreList" />
      <tip-modal v-if="tipShow" :show.sync="tipShow" :options="tipOptions" @confirm="tipConfirm" @cancel="tipCancel">
        <template slot="content">
          <p v-if="tipOptions.type === 3">{{ this.topicInfo.main_name }}<span>{{ topicInfo.mileage_name }}</span>未得分，即将结束本维度测评，是否确认？</p>
          <p v-if="tipOptions.type === 4">本维度的测评已结束，下一个测评维度是<span>{{ dimensionList[tipOptions.nextIndex].main_name }}</span></p>
        </template>
      </tip-modal>
      <self-modal v-if="!subtopicShow && selfInfo.topic_id" :info="selfInfo" />
    </div>
    <van-overlay :show="overlayShow" :custom-style="{ background: 'rgba(0,0,0,0)', zIndex: '99' }" @click="overlayTip" :lock-scroll="false" />
  </div>
</template>

<script>
import TopicHeader from './components/TopicHeader';
import TableTopic from "./components/topics/TableTopic";
import JudgmentTopic from "./components/topics/JudgmentTopic";
import PracticeTopic from "./components/topics/PracticeTopic";
import TimeTopic from './components/topics/TimeTopic';
import SingleTopic from './components/topics/SingleTopic';
import LabelTopic from './components/topics/LabelTopic';
import TopicFooter from './components/TopicFooter';
import ScoreModal from './components/ScoreModal';
import TipModal from "./components/TipModal";
import SelfModal from './components/SelfModal';
import { getuid, settopicid, setlesson_id, setltemname, getreviewid, gettopicid, getlesson_id, getltemname } from "/src/api/userdata.js";
import { Toast } from "vant";
export default {
  name: "Topic",
  components: {
    TopicHeader,
    TableTopic,
    JudgmentTopic,
    PracticeTopic,
    TimeTopic,
    SingleTopic,
    LabelTopic,
    TopicFooter,
    ScoreModal,
    SelfModal,
    TipModal
  },
  data() {
    return {
      topicInfo: {},
      projectVisible: false,
      tableTotal: 0,
      scoreList: [],
      tipShow: false,
      tipOptions: {},
      dimensionList: [],
      tempScore: '',
      isHand: false, // 是否手动打分
      score: '',
      overlayShow: false,
      subtopicShow: false,
      subtopicInfo: {},
      statisticsInfo: {},
      selfInfo: {}
    };
  },
  watch: {
    $route(to, from) {
      // 监听路由变化，如果是topic页面则重新获取信息
      if (to.name === 'topic') {
        Object.assign(this.$data, this.$options.data())
        this.getInfo();
        this.getScoreList();
        this.getDimensionList();
      }
    }
  },
  created() {
    // if (this.$route.query.not * 1 === 1) {
    //   this.overlayShow = true;
    // }
    this.getInfo();
    this.getScoreList();
    this.getDimensionList();
  },
  beforeUnmount() {
    localStorage.removeItem('trecord_id');
    localStorage.removeItem('toprecord_id');
  },
  methods: {
    async getInfo() {
      const uid = getuid();
      const review_id = getreviewid();
      const main_id = gettopicid();
      let path = ['must-topic/next-content', 'must-topicrecord/get'][this.$route.query.topic_sort > 0 ? 1 : 0];
      let params = {
        uid,
        review_id,
        main_id,
      }
      if (this.$route.query.topic_sort > 0) {
        params.topic_sort = this.$route.query.topic_sort;
        params.type = this.$route.query.type;
      } else {
        params.is_rec = this.$route.query.is_rec;
        params.trec_id = this.$route.query.trec_id;
        params.topic_id = this.$route.query.topic_id;
      }
      const res = await this.$http.get(path, { params: params });
      if (res.code * 1 !== 1) {
        return this.$vantnotify(res.msg);
      }
      this.topicInfo = res.data;
      this.score = this.topicInfo.score ? this.topicInfo.score * 1 : '';
      this.isHand = this.topicInfo.is_hand * 1 > 0 ? true : false;
      if (this.$route.query.topic_sort > 0) {
        this.topicInfo.topic_info.operate = this.topicInfo.topic_info.operate.length > 0 ? this.txtTransform(this.topicInfo.topic_info.operate) : '无';
      } else {
        this.topicInfo.operate = this.topicInfo.operate.length > 0 ? this.txtTransform(this.topicInfo.operate) : '无';
      }
      this.$nextTick(() => {
        this.getSelfRecord(uid);
      })
    },
    // 获取自评记录
    async getSelfRecord(uid) {
      let params = {
        uid,
        lesson_id: this.topicInfo.lesson_id,
        manor_id: this.topicInfo.manor_id,
        main_id: this.topicInfo.main_id,
        stage_id: this.topicInfo.stage_id,
        mileage_id: this.topicInfo.mileage_id
      }
      const res = await this.$http.get('must-topic/jia-rec', { params: params });
      if (res.code * 1 !== 1) {
        return this.$vantnotify(res.msg);
      }
      this.selfInfo = res.data;
    },
    txtTransform(str) {
      return str.replace(/\n/g, "<br>");
    },
    async getScoreList() {
      const uid = getuid();
      const review_id = getreviewid();
      const main_id = gettopicid();
      let params = {
        uid,
        review_id,
        main_id,
        type: 0
      }
      const res = await this.$http.get('must-trecord/trecord', { params: params });
      if (res.code * 1 !== 1) {
        return this.$vantnotify(res.msg);
      }
      this.scoreList = res.data instanceof Array ? res.data : [];
    },
    async getDimensionList() {
      const uid = getuid();
      const review_id = getreviewid();
      let pathArr = ['must-topic/main-list', 'must-topic/skill-list', 'must-topic/feel-list', 'must-topic/rim-list']
      let params = {
        uid,
        review_id
      }
      const res = await this.$http.get(pathArr[this.$route.query.eva_type], { params: params });
      if (res.code * 1 !== 1) {
        return this.$vantnotify(res.msg);
      }
      this.dimensionList = res.data.list;
    },
    handleToggleProject() {
      this.projectVisible = !this.projectVisible;
    },
    tableTotalChange(val) {
      this.tableTotal = val;
    },
    toggleMode(isHand) {
      this.$nextTick(() => {
        if (isHand) {
          this.score = '';
        } else {
          this.$refs[`topictype${this.topicInfo.topic_type}`].calculateScore();
        }
      });
    },
    async onClickPrev() {
      const uid = getuid();
      const review_id = getreviewid();
      const main_id = gettopicid();
      let params = {
        uid,
        review_id,
        main_id,
        topic_sort: this.topicInfo.topic_sort
      }
      const res = await this.$http.get('must-topicrecord/up-topic', { params: params });
      if (res.code * 1 !== 1) {
        return this.$vantnotify(res.msg);
      }
      this.$router.replace({
        name: 'topic',
        query: {
          topic_sort: res.data.topic_sort,
          type: 1,
          ass_num: this.$route.query.ass_num,
          eva_type: this.$route.query.eva_type
        }
      });
    },
    async onClickNext() {
      if ((!this.score || this.score === '') && this.score !== 0) {
        this.tipOptions = {
          type: 2,
          message: "请作答当前题目",
          cancelHide: true
        };
        return this.tipShow = true;
      }
      if (this.score === 0) {
        this.tipOptions = {
          type: 3
        };
        return this.tipShow = true;
      }
      const uid = getuid();
      const review_id = getreviewid();
      const main_id = gettopicid();
      const topicRes = await this.addTopicRecord(uid, review_id, main_id);
      if (topicRes.code * 1 !== 1) {
        return this.$vantnotify(topicRes.msg);
      }
      localStorage.removeItem('trecord_id');
      localStorage.removeItem('toprecord_id');
      let topicId = this.$route.query.topic_sort > 0 ? this.topicInfo.topic_info.id : this.topicInfo.id
      if (topicId * 1 === this.scoreList[this.scoreList.length - 1].id * 1) {
        const dimensionRes = await this.submitDimensionRecords(uid, review_id, main_id);
        if (dimensionRes.code * 1 !== 1) {
          return this.$vantnotify(dimensionRes.msg);
        }
      } else {
        let res = await this.getNextInfo(main_id, this.topicInfo.topic_sort, topicRes.data.trecord_id)
        if (res.code * 1 === 9100) {
          const dimensionRes = await this.submitDimensionRecords(uid, review_id, main_id);
          if (dimensionRes.code * 1 !== 1) {
            return this.$vantnotify(dimensionRes.msg);
          }
          return false
        } else if (res.code * 1 !== 1) {
          return this.$vantnotify(res.msg);
        }
        this.$router.replace({
          name: 'topic',
          query: {
            prosort: this.topicInfo.topic_sort,
            ass_num: this.$route.query.ass_num,
            eva_type: this.$route.query.eva_type,
            is_rec: res.data.is_rec,
            trec_id: res.data.trec_id,
            topic_id: res.data.topic_id,
            topic_sort: res.data.is_rec ? res.data.topic_sort : '',
          }
        });
      }
    },
    async tipConfirm() {
      if (this.tipOptions.type === 3) {
        const uid = getuid();
        const review_id = getreviewid();
        const main_id = gettopicid();
        const topicRes = await this.addTopicRecord(uid, review_id, main_id);
        if (topicRes.code * 1 !== 1) {
          return this.$vantnotify(topicRes.msg);
        }
        const dimensionRes = await this.submitDimensionRecords(uid, review_id, main_id);
        if (dimensionRes.code * 1 !== 1) {
          return this.$vantnotify(dimensionRes.msg);
        }
        if (this.tipOptions.type === 4) {
          return
        }
      }
      if (this.tipOptions.type === 4) {
        let nextDimension = this.dimensionList[this.tipOptions.nextIndex]
        settopicid(nextDimension.main_id);
        setltemname(nextDimension.main_name);
        let res = await this.getNextInfo(nextDimension.main_id, 0)
        this.$router.replace({
          name: 'topic',
          query: {
            ass_num: this.$route.query.ass_num,
            eva_type: this.$route.query.eva_type,
            is_rec: res.data.is_rec,
            trec_id: res.data.trec_id,
            topic_id: res.data.topic_id,
            topic_sort: res.data.is_rec ? res.data.topic_sort : '',
          }
        });
      }
      if (this.tipOptions.type === 5) {
        this.$router.go(-1);
      }
      this.tipShow = false;
    },
    tipCancel() {
      if (this.tipOptions.type === 4) {
        this.$router.go(-1)
      }
      this.tipShow = false;
    },
    subtopicChange(val) {
      this.$set(this, 'subtopicInfo', val)
    },
    statisticsChange(val) {
      this.$set(this, 'statisticsInfo', val)
    },
    async addTopicRecord(uid, review_id, main_id) {
      if (this.submitloading) return
      let path = 'must-topicrecord/add'
      let params = {
        trecord_id: this.topicInfo.trecord_id,
        toprecord_id: this.topicInfo.toprecord_id,
        uid: uid,
        review_id,
        main_id,
        topic_id: this.$route.query.topic_sort > 0 ? this.topicInfo.topic_info.id : this.topicInfo.id,
        score: this.score,
        is_hand: this.isHand ? 1 : 0,
      }
      if (this.topicInfo.topic_type * 1 === 2) {
        path = 'must-topicrecord/up-host'
        // let trecordId = this.topicInfo.trecord_id * 1 > 0 ? this.topicInfo.trecord_id : localStorage.getItem('trecord_id');
        // let toprecordId = this.topicInfo.toprecord_id * 1 > 0 ? this.topicInfo.toprecord_id : localStorage.getItem('toprecord_id');
        let data = {
          uid: uid,
          review_id,
          lesson_id: this.topicInfo.lesson_id,
          manor_id: this.topicInfo.manor_id,
          main_id,
          stage_id: this.topicInfo.stage_id,
          mileage_id: this.topicInfo.mileage_id,
          topic_id: this.$route.query.topic_sort > 0 ? this.topicInfo.topic_info.id : this.topicInfo.id,
        }
        const idRes = await this.$http.post('must-topicrecord/host', data);
        if (idRes.code * 1 !== 1) {
          return this.$vantnotify(idRes.msg);
        }
        let trecordId = idRes.data.trecord_id;
        let toprecordId = idRes.data.topicrecord_id;
        params.trecord_id = trecordId || 0;
        params.toprecord_id = toprecordId || 0;
      }
      if (this.topicInfo.topic_type * 1 === 3) {
        let arr = this.$refs.topictype3.answerRecord;
        params.ans_record = arr.length > 0 ? JSON.stringify(arr) : '';
      }
      if (this.topicInfo.topic_type * 1 === 4) {
        let arr = this.$refs.topictype4.answerRecord;
        if (this.topicInfo.tim_type * 1 === 1) {
          params.ans_record = arr.length > 0 ? JSON.stringify(arr.map(e => {
            let { formattedTime, ...item } = e;
            return item
          })) : '';
          params.r_time = this.$refs.topictype4.effectiveTime.time;
        }
        if (this.topicInfo.tim_type * 1 === 2) {
          params.ans_record = arr.length > 0 ? JSON.stringify(arr.map((item, index) => {
            let name = `第${this.$refs.topictype4.numberToChinese(index + 1)}次`
            return {
              num: index + 1,
              name,
              time: item.time
            }
          })) : '';
          params.f_num = arr.length;
        }
      }
      if (this.topicInfo.topic_type * 1 === 5) {
        let arr = this.$refs.topictype5.answerRecord;
        params.ans_record = arr.length > 0 ? JSON.stringify(arr) : '';
      }
      if (this.topicInfo.topic_type * 1 === 6) {
        let arr = this.$refs.topictype6.answerRecord;
        params.ans_record = arr.length > 0 ? JSON.stringify(arr) : '';
        params.r_num = arr.length;
      }
      // console.log('params', params);
      // return {code: 1}
      this.submitloading = true;
      const res = await this.$http.post(path, params);
      this.submitloading = false;
      return res;
    },
    async submitDimensionRecords(uid, review_id, main_id) {
      if (this.submitloading) return
      let index = this.dimensionList.findIndex(item => item.main_id * 1 === main_id * 1);
      if (index === -1) {
        this.$vantnotify('未找到此维度');
        return false;
      };
      let params = {
        uid,
        review_id,
        main_id,
        lesson_id: this.dimensionList[index].lesson_id || ''
      }
      // console.log('params', params);
      // return { code: 1 }
      this.submitloading = true;
      const res = await this.$http.post('must-trecord/finish-asses', params);
      let nextIndex = -1;
      // 1、先判断后边是否有状态为未评估和评估中的维度
      for (let i = index + 1; i < this.dimensionList.length; i++) {
        if (this.dimensionList[i].status * 1 !== 1) {
          nextIndex = i;
          break;
        }
      }
      // 2、然后再判断前边是否有状态为未评估和评估中的维度
      if (nextIndex === -1) {
        for (let i = 0; i < index; i++) {
          if (this.dimensionList[i].status * 1 !== 1) {
            nextIndex = i;
            break;
          }
        }
      }
      // 3、如果有则跳到下一维度，都没有则本次评估完成
      if (nextIndex !== -1) {
        this.tipOptions = {
          type: 4,
          cancelText: '手动调整',
          confirmText: '继续评估',
          nextIndex,
          closeHide: true
        };
        this.$nextTick(() => {
          this.tipShow = true;
        });
      } else {
        this.tipShow = false;
        Toast.success({
          duration: 3000,
          forbidClick: true,
          message: "恭喜你，完成评估",
          onClose: () => {
            this.$router.go(-1)
          },
        });
      }
      this.submitloading = false;
      return res;
    },
    async getNextInfo(main_id, topic_sort, trecord_id) {
      const uid = getuid();
      const review_id = getreviewid();
      let params = {
        uid,
        review_id,
        main_id,
        topic_sort,
        trecord_id: trecord_id || ''
      }
      const res = await this.$http.get('must-topic/next-topic', { params: params });
      return res
    },
    async complete() {
      if ((!this.score || this.score === '') && this.score !== 0) {
        this.score = 0
      }
      const uid = getuid();
      const review_id = getreviewid();
      const main_id = gettopicid();
      const topicRes = await this.addTopicRecord(uid, review_id, main_id);
      if (topicRes.code * 1 !== 1) {
        return this.$vantnotify(topicRes.msg);
      }
      const dimensionRes = await this.submitDimensionRecords(uid, review_id, main_id);
      if (dimensionRes.code * 1 !== 1) {
        return this.$vantnotify(dimensionRes.msg);
      }
    },
    overlayTip() {
      this.tipOptions = {
        type: 5,
        message: "当前状态可查看，但无法编辑，点击确认即可返回维度列表"
      };
      this.tipShow = true;
    }
  },
}
</script>

<style lang="less" scoped>
.topic-page {
  height: 100vh;
  height: 100dvh;
  background: url("~@/assets/img/page-bg2.png") top left/100% 100% no-repeat;
  padding-top: 0.06rem;
  &::before {
    content: "";
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 1.3rem;
    background: url("~@/assets/img/page-bg3.png") top left/100% 100% no-repeat;
  }
  .page-content {
    height: calc(100vh - 0.9rem);
    height: calc(100dvh - 0.9rem);
    position: relative;
    display: flex;
    flex-direction: column;
    align-items: center;
    padding-bottom: 0.2rem;
  }
  ::v-deep .topic-type {
    flex: 1;
    width: 100%;
    height: 100%;
    min-height: 78vh;
    padding: 0.06rem 0.16rem 0.1rem;
  }
  ::v-deep .topic-container {
    height: 100%;
    background: #fffaf5;
    box-shadow: 0.02rem 0.02rem 0 1px #ffb453;
    border-radius: 0.2rem;
    display: flex;
    flex-direction: column;
  }
  .topic-footer {
    width: 100%;
    padding: 0 0.16rem;
    position: fixed;
    bottom: 0.1rem;
    left: 0;
    z-index: 99;
  }
}
.tip-modal span {
  color: #d45500;
}
</style>